var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSunrise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.75C26.6985 33.75 33.75 26.6985 33.75 18C33.75 9.30152 26.6985 2.25 18 2.25C9.30152 2.25 2.25 9.30152 2.25 18C2.25 26.6985 9.30152 33.75 18 33.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.995 23.01V24.435H28.02V23.01H7.995Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 20.865C22.29 19.725 21.84 18.63 21.03 17.835C20.22 17.04 19.14 16.575 18 16.575C16.86 16.575 15.765 17.025 14.97 17.835C14.16 18.645 13.71 19.725 13.71 20.865H22.29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.005 19.425H24.435V20.85H28.005V19.425Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 13.275L22.065 15.78L23.07 16.785L25.575 14.28L24.57 13.275Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.555L14.43 10.125L15.435 11.13L17.28 9.285V14.415H18.705V9.285L20.55 11.13L21.555 10.125L17.985 6.555H18Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 13.275L10.425 14.28L12.93 16.785L13.935 15.78L11.43 13.275Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.565 19.425H7.995V20.85H11.565V19.425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSunrise);
export default __webpack_public_path__ + "static/media/ic-sunrise.8cc8d872bbcbcd6be162eb803b0378cf.svg";
export { ForwardRef as ReactComponent };